export enum WorkItemLaneType {
  SmartAdvisor,

  CannedMessage,

  VisitorInfo,

  PopupIntegration,

  EmbeddedIntegration,

  SalesforceIntegration,

  Discussions,

  VisitorHistory
}
